import React, { useEffect, useState } from 'react'
import { errorPopup } from '../../utils/PopUpMessage';
import { useNavigate } from "react-router-dom";
import { InfoSvg, RightArrowSvg } from './svgIcon';
import "../../Css/token.css"
import '../Model.jsx'
import Model from '../Model.jsx'
import web3 from 'web3';

export default function CreateToken(props) {
    const [user, setUser] = useState({
        token_name: "",
        token_sym: "",
        total_supply: "1000"
    })
    const [type, setType] = useState()
    const [freeType, setFreeType] = useState(false)
    const [basicType, setBasicType] = useState(false)
    const [customType, setCustomType] = useState(false)
    const [protocol, setProtocol] = useState(false)
    const [verified, setVerified] = useState(false)
    const [copyrightCheck, setCopyRightCheck] = useState(false)
    const [copyrightEnable, setCopyRightEnalbe] = useState(true)
    const [mintableChecked, setMintableChecked] = useState(false)
    const [mintableDisabled, setMintableDisabled] = useState(true)
    const [burnable, setBurnable] = useState(true)
    const [pausable, setPausable] = useState(true)
    const [recoverable, setRecoverable] = useState(true)
    const [accessType, setAccessType] = useState(true)
    const [supplyType, setSupplyType] = useState(true)
    const [initialSupply, setInitialSupply] = useState(true)
    const [maxSupply, setMaxSupply] = useState(true)
    const [decimal, setDecimal] = useState(true)
    const [supply, setSupply] = useState()
    const [hide, setHide] = useState(false)
    const [initialValue, setInitialValue] = useState('1000')


    const navigate = useNavigate();

    // const [checked, setChecked] = useState(false);


    useEffect(() => {
        if (type == "free") {
            setDecimal(true)
            setInitialSupply(true)
            setSupplyType(true)
            setCopyRightCheck(false)
            setCopyRightEnalbe(true)
            setBurnable(true)
            setPausable(true)
            setRecoverable(true)
            setAccessType(true)
            setMintableChecked(false)
            setMintableDisabled(true)
            setSupply('fixed')
            setMaxSupply(true)

        } else if (type == "basic") {
            setDecimal(true)
            setInitialSupply(false)
            setSupplyType(true)
            setCopyRightCheck(false)
            setCopyRightEnalbe(true)
            setBurnable(true)
            setPausable(true)
            setRecoverable(true)
            setAccessType(true)
            setMintableChecked(false)
            setMintableDisabled(true)
            setSupply('fixed')



        } else if (type == "custom") {
            setDecimal(false)
            setInitialSupply(false)
            setSupplyType(false)
            setCopyRightCheck(true)
            setCopyRightEnalbe(true)
            setMintableChecked(false)
            setMintableDisabled(true)
            setBurnable(false)
            setPausable(false)
            setRecoverable(false)
            setAccessType(false)


        }

    }, [type])

    useEffect(() => {
        if (supply == "fixed") {

            setMintableChecked(false)
            setMintableDisabled(true)
            setHide(false)

        }
        else if (supply == "capped") {

            setMintableChecked(true)
            setMintableDisabled(false)
            setHide(false)
            setMaxSupply(false)

        }

        else if (supply == "unlimited") {

            setMintableChecked(true)
            setMintableDisabled(false)
            setHide(true)

        }



    }, [supply])

    const handleClick = e => {
        e.preventDefault();
        const { name, value } = e.target;
        setUser(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const CreateTokenDetails = async (e) => {
        e.preventDefault();
        console.log(window.ethereum.networkVersion, props.network);
        if (window.ethereum.networkVersion !== props.network) {
            try {
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: web3.utils.toHex(props?.network) }]
                });
            } catch (err) {
                console.log(err);
                errorPopup('Network Reject')


            }
        } else {
            let data = user;
            console.log("user:", data)
            navigate(`/installation`, {
                state: {
                    data
                }
            });
        }
        // navigate('/installation')
    }
    return (

        <>

            <div className='container'>
                <div className='configuration'>
                    <form onSubmit={CreateTokenDetails}>
                        <div className='row'>
                            <div className='col-xl-4 col-lg-6 col-md-4 text-start'>
                                <div className='card'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Information</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='form-group'>
                                            <label for="TokenTypeField" className="form-label">Token Type *</label>
                                            <select className="form-select" aria-label="Default select example"
                                                onChange={(e) => { setType(e.target.value) }} id="TokenTypeField">
                                                {/* <option selected>Open this select menu</option> */}
                                                <option value="free">Free</option>
                                                <option value="basic">Basic</option>
                                                <option value="custom" >Custom</option>
                                            </select>
                                            <div id="emailHelp" className="form-text">Select the base configuration of your token (Free and Basic have limited configurations)</div>
                                        </div>
                                        <div className='form-group'>
                                            <label for="TokenNameField" class="form-label">Token Name*</label>
                                            <input type="text"
                                                className="form-control"
                                                id="TokenNameField"
                                                name="token_name"
                                                onChange={handleClick}
                                                value={user?.token_name}
                                                placeholder="My New Token"
                                                aria-describedby="emailHelp"
                                                required
                                            />
                                            <div id="emailHelp" className="form-text">The name of your token</div>
                                        </div>
                                        <div className='form-group'>

                                            <label for="TokenNameField" class="form-label">Token Symbol*</label>
                                            <input type="text"
                                                className="form-control"
                                                name="token_sym"
                                                onChange={handleClick}
                                                value={user?.token_sym}
                                                placeholder="TKN"
                                                style={{textTransform:"uppercase"}}
                                                id="TokenNameField" aria-describedby="emailHelp"
                                                required
                                            />
                                            <div id="emailHelp" className="form-text">You token's symbol (ie ETH)</div>

                                        </div>
                                        <div className='form-group'>
                                            <label for="disabledTextInput" class="form-label">Decimals*</label>
                                            <input type="text" id="disabledTextInput" class="form-control" placeholder="18" disabled={decimal} />
                                            <div id="emailHelp" className="form-text">The number of decimal of your token (default 18)</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card mt-3'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Supply</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='form-group'>
                                            <label for="disabledTextInput" className="form-label">Supply type*</label>
                                            <select className="form-select" aria-label="Default select example" id="disabledTextInput" value={supply} onChange={(e) => {
                                                setSupply(e.target.value)
                                            }} disabled={supplyType}>
                                                {/* <option selected>Open this select menu</option> */}
                                                <option value="fixed">Fixed</option>
                                                <option value="capped">Capped</option>
                                                <option value="unlimited">Unlimited</option>
                                            </select>
                                            <div id="emailHelp" className="form-text">Fixed / Capped / Unlimited
                                            </div>
                                        </div>
                                        <div className='form-group'>
                                            <label for="InitialSupplyField" class="form-label">Initial supply*</label>
                                            <input type="number"
                                                className="form-control"
                                                id="InitialSupplyField"
                                                name="total_supply"
                                                aria-describedby="emailHelp" disabled={initialSupply} onChange={(e) => { setUser({ ...user, total_supply: e.target.value }); handleClick() }} value={user.total_supply} />
                                            <div id="emailHelp" className="form-text">The number of coins minted during the creation of the contract</div>
                                        </div>
                                        {
                                            hide == true ? "" :
                                                <div className='form-group'>
                                                    <label for="disabledTextInput" class="form-label">Maximum supply*</label>
                                                    <input type="text" id="disabledTextInput" class="form-control" placeholder="1000" value={user.total_supply} disabled={maxSupply} />
                                                    <div id="emailHelp" className="form-text">The maximum number of coins ever minted
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className='col-xl-4 col-lg-6 col-md-4 mt-3 mt-lg-0 text-start'>
                                <div className='card'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Options</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='form-check form-switch'>
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckCheckedDisabled" checked disabled />
                                            <label class="form-check-label" for="flexSwitchCheckCheckedDisabled">Conforms to ERC20 protocol</label>
                                            <div id="emailHelp" className="form-text">Your token will const all the functionalities, and conforms to ERC20 protocol</div>
                                        </div>
                                        <div className='form-check form-switch'>
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckCheckedDisabled" checked disabled />
                                            <label class="form-check-label" for="flexSwitchCheckCheckedDisabled">Verified on Etherscan</label>
                                            <div id="emailHelp" className="form-text">The source code of your contract is automatically published and verified</div>
                                        </div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" checked={copyrightCheck} disabled={copyrightEnable} />
                                            <label class="form-check-label" for="flexSwitchCheckDisabled">No copyright link
                                            </label>
                                            <div id="emailHelp" className="form-text">A link pointing to this page will be added in the description of your contract (Free and Basic contracts only)
                                            </div>
                                        </div>

                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox"
                                                id="flexSwitchCheckDisabled"
                                                checked={mintableChecked}
                                                disabled={mintableDisabled}
                                                onChange={(() => {
                                                    setMintableChecked(!mintableChecked)

                                                })}

                                            />
                                            <label class="form-check-label" for="flexSwitchCheckDisabled">Mintable</label>
                                            <div id="emailHelp" className="form-text">Allow the creation of new tokens in the future
                                            </div>
                                        </div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" disabled={burnable} />
                                            <label class="form-check-label" for="flexSwitchCheckDisabled">Burnable</label>
                                            <div id="emailHelp" className="form-text">Allow your tokens to be burned
                                            </div>
                                        </div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" disabled={pausable} />
                                            <label class="form-check-label" for="flexSwitchCheckDisabled">Pausable</label>
                                            <div id="emailHelp" className="form-text">Allow your tokens to be paused
                                            </div>
                                        </div>
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" disabled={recoverable} />
                                            <label class="form-check-label" for="flexSwitchCheckDisabled">Recoverable</label>
                                            <div id="emailHelp" className="form-text">Allow to recover any ERC20 tokens sent to your contract
                                            </div>
                                        </div>

                                        <div className='form-group'>
                                            <label for="disabledTextInput" className="form-label">Access type*</label>
                                            <select className="form-select" aria-label="Default select example" id="disabledTextInput" disabled={accessType}>
                                                {/* <option selected>Open this select menu</option> */}
                                                <option value="owner">Owner</option>
                                                <option value="roles">Roles</option>
                                            </select>
                                            <div id="emailHelp" className="form-text">Who can administer your contract

                                            </div>

                                            <div id="emailHelp" className="form-text"><b>Owner:</b> Your wallet address will be set as the owner of your token to perform administratives tasks (ie, mint new tokens).

                                            </div>
                                            <div id="emailHelp" className="form-text"><b>Roles:</b> All admin tasks (mint, burn, etc...) will be available to different users, based on their roles. By default, your wallet's address will be given all the roles.

                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className='col-xl-4 col-lg-6 col-md-4 mt-3 mt-xl-0 text-start'>
                                <div className='card'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Network</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='form-group'>

                                            <select className="form-select" aria-label="Default select example"
                                                value={props.network}
                                                onChange={(e) => {
                                                    props.changenetwork(e.target.value)
                                                    console.log(e.target.value)
                                                }}
                                            >
                                                <option value="1">Mainnet</option>
                                                <option value="5">Gorli</option>
                                            </select>
                                            <div id="emailHelp" className="form-text">Select the network on wich you want to deploy your token</div>
                                        </div>

                                    </div>
                                </div>
                                <div className='card mt-3'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Agreement</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div class="mb-3 form-check">
                                            <input type="checkbox" class="form-check-input" id="exampleCheck1" required />
                                            <label class="form-check-label" for="exampleCheck1">I have read, understood and agreed to the <span style={{ textDecoration: "underline", cursor: "pointer" }}
                                                data-bs-toggle="modal" data-bs-target="#exampleModal">Terms of Use.</span></label>

                                            <Model />
                                        </div>
                                    </div>
                                </div>

                                <div className='card mt-3'>
                                    <div className='card-header d-flex align-items-center'>
                                        <div className='mr-3' ><RightArrowSvg /></div>
                                        <h4>Transaction</h4>
                                    </div>
                                    <div className='card-body'>
                                        <div className='col mt-3 d-flex'>
                                            <div className='col'>
                                                <p>Commission fee: <InfoSvg /></p>
                                            </div>
                                            <div className='col-5 col-xl-4'>
                                                <span className='badge bg-success d-block p-2'>Free</span>
                                            </div>

                                        </div>
                                        <div className='col mt-1 d-flex'>
                                            <div className='col'>
                                                <p>Gas fee: <InfoSvg /></p>
                                            </div>
                                            <div className='col-5 col-xl-4'>
                                                <span className='badge bg-secondary d-block p-2'>Variable</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                             
                                <div className='mt-3'>
                                    <button type="submit" class="btn btn-lg btn-success w-100" 
                                    disabled={props.confirm}
                                    
                                    >Confirm</button> 
                                </div>

                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
